import RAPIER from "@dimforge/rapier3d-compat";

import { PhysicsTable, SlideConfig } from "../../../entities/physics_table.js";

export const SLIDE_CONFIG: SlideConfig = {
  distance: 0.9,
  periodSec: 4,
};

export class TableSlider
{
  private time = 0;
  private offset = 0;

  constructor(
    private readonly table: PhysicsTable,
    private readonly config: SlideConfig,
    private readonly get_bodies: () => Iterable<RAPIER.RigidBody>
  )
  {}

  public step( dt: number ): void
  {
    this.time += dt;

    const period = Math.max( this.config.periodSec, 0.1 );
    const next = this.config.distance * Math.sin( this.time * ( 2 * Math.PI / period ) );

    const delta = next - this.offset;
    this.offset = next;

    if ( delta !== 0 )
      this.carry( delta );

    this.table.setSlide( this.offset );
  }

  private carry( delta: number ): void
  {
    for ( const body of this.get_bodies() )
    {
      if ( !body.isValid() )
        continue;

      const p = body.translation();

      if ( this.table.isOutside( p ) )
        continue;

      body.setTranslation( { x: p.x + delta, y: p.y, z: p.z }, false );
    }
  }
}
